module.exports = __webpack_public_path__ + "/images/cover-cta-happy-pregnant-m.9199fdb.png";